var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("el-backtop", {
    attrs: {
      bottom: 100
    }
  }, [_c("div", {
    staticStyle: {
      height: "100%",
      width: "100%",
      "background-color": "var(--el-bg-color-overlay)",
      "box-shadow": "var(--el-box-shadow-lighter)",
      "text-align": "center",
      "line-height": "40px",
      color: "#1989fa",
      display: "flex",
      "align-items": "center",
      "justify-content": "center",
      "border-radius": "50%"
    }
  }, [_c("i", {
    staticClass: "el-icon-arrow-up",
    staticStyle: {
      "font-size": "20px"
    }
  })])]), _c("div", {
    staticClass: "filter-header",
    staticStyle: {
      display: "flex",
      "justify-content": "space-between",
      "margin-bottom": "10px"
    }
  }, [_c("el-button", {
    attrs: {
      type: "primary",
      size: "mini"
    },
    on: {
      click: function ($event) {
        _vm.showFilters = !_vm.showFilters;
      }
    }
  }, [_vm._v(" Filters & More "), _c("i", {
    class: _vm.showFilters ? "el-icon-arrow-up" : "el-icon-arrow-down",
    staticStyle: {
      "margin-left": "5px"
    }
  })])], 1), _vm.showFilters ? _c("div", {
    staticClass: "filter-container"
  }, [_c("el-select", {
    staticClass: "filter-item",
    attrs: {
      filterable: "",
      clearable: "",
      remote: "",
      loading: _vm.dealerListLoading,
      "loading-text": "fetching dealers..",
      "remote-method": _vm.getDealerList,
      placeholder: _vm.$t("dealersDispatch.dealer")
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.dealerId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "dealerId", $$v);
      },
      expression: "listQuery.dealerId"
    }
  }, _vm._l(_vm.dealerList, function (dealer) {
    return _c("el-option", {
      key: dealer.id,
      attrs: {
        label: dealer.name,
        value: dealer.id
      }
    }, [_c("span", {
      staticStyle: {
        float: "left",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(dealer.name) + " - " + _vm._s(dealer.code))]), _c("span", {
      staticStyle: {
        float: "right",
        color: "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("   | ID: " + _vm._s(dealer.id))])]);
  }), 1), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      filterable: "",
      remote: "",
      clearable: "",
      "remote-method": _vm.getProductList,
      loading: _vm.productListLoading,
      placeholder: "Select Product"
    },
    on: {
      change: _vm.handleProductSelection
    },
    model: {
      value: _vm.selectedProduct,
      callback: function ($$v) {
        _vm.selectedProduct = $$v;
      },
      expression: "selectedProduct"
    }
  }, _vm._l(_vm.products, function (product) {
    return _c("el-option-group", {
      key: product.id,
      attrs: {
        label: "Main Product"
      }
    }, [_c("el-option", {
      key: "product-" + product.id,
      attrs: {
        label: product.name,
        value: "product-" + product.id
      }
    }, [_c("span", {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(product.name))])]), product.productType !== "simple" && product.productsVariation && product.productsVariation.length ? [_c("el-option", {
      key: "variations-label-" + product.id,
      attrs: {
        label: "Variations",
        disabled: ""
      }
    }, [_c("span", {
      staticStyle: {
        "font-style": "italic",
        color: "gray"
      }
    }, [_vm._v("Variations:")])]), _vm._l(product.productsVariation, function (item) {
      return _c("el-option", {
        key: item.id,
        attrs: {
          label: product.name + "-" + item.name,
          value: "variation-" + item.id
        }
      }, [_c("span", [_vm._v(_vm._s(item.name))])]);
    })] : _vm._e()], 2);
  }), 1), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      clearable: "",
      placeholder: "Status"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.status,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "status", $$v);
      },
      expression: "listQuery.status"
    }
  }, _vm._l(_vm.statusOptions, function (item) {
    return _c("el-option", {
      key: item,
      attrs: {
        label: item,
        value: item
      }
    });
  }), 1), _c("el-input", {
    staticClass: "filter-item",
    attrs: {
      placeholder: "Invoice Number"
    },
    nativeOn: {
      keyup: function ($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.handleFilter.apply(null, arguments);
      }
    },
    model: {
      value: _vm.listQuery.entryNumber,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "entryNumber", $$v);
      },
      expression: "listQuery.entryNumber"
    }
  }), _c("el-select", {
    staticClass: "filter-item",
    staticStyle: {
      width: "140px"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.sort,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "sort", $$v);
      },
      expression: "listQuery.sort"
    }
  }, _vm._l(_vm.sortOptions, function (item) {
    return _c("el-option", {
      key: item.key,
      attrs: {
        label: item.label,
        value: item.key
      }
    });
  }), 1), _c("VueCtkDateTimePicker", {
    staticClass: "filter-item",
    attrs: {
      range: "",
      formatted: "DD-MM-YYYY",
      "custom-shortcuts": _vm.shortcuts
    },
    model: {
      value: _vm.dateRange,
      callback: function ($$v) {
        _vm.dateRange = $$v;
      },
      expression: "dateRange"
    }
  }), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "primary",
      icon: "el-icon-search",
      size: "mini"
    },
    on: {
      click: _vm.handleFilter
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("table.search")) + " ")])], 1) : _vm._e(), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.listLoading,
      expression: "listLoading"
    }],
    key: _vm.tableKey,
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.list,
      border: "",
      fit: "",
      "highlight-current-row": ""
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c("el-table-column", {
    attrs: {
      sortable: "custom",
      width: "80",
      align: "center",
      label: "ID",
      prop: "id",
      "class-name": _vm.getSortClass("id")
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.id) + " "), _c("br")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      sortable: "custom",
      width: "80",
      align: "center",
      prop: "entryNumber",
      label: "Lot No",
      "class-name": _vm.getSortClass("entryNumber")
    }
  }), _c("el-table-column", {
    attrs: {
      width: "120",
      align: "center",
      prop: "invoiceNumber",
      label: "Invoice No"
    }
  }), _c("el-table-column", {
    attrs: {
      width: "350px",
      prop: "dealer",
      label: "Dealer",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return scope.row.dealer ? [scope.row.dealer.name ? _c("b", [_c("i", {
          staticClass: "el-icon-suitcase"
        }), _vm._v(" " + _vm._s(scope.row.dealer.name) + " "), _c("br")]) : _vm._e(), scope.row.dealer.city ? _c("i", {
          staticClass: "el-icon-place"
        }, [_vm._v(" " + _vm._s(scope.row.dealer.city) + " "), _c("br")]) : _vm._e(), scope.row.dealer.code ? _c("span", [_vm._v(" (" + _vm._s(scope.row.dealer.code) + ") "), _c("br")]) : _vm._e(), _c("el-tag", {
          attrs: {
            size: "mini",
            type: _vm.statusColorMap[scope.row.status]
          }
        }, [_vm._v(" " + _vm._s(scope.row.status) + " ")])] : undefined;
      }
    }], null, true)
  }), _c("el-table-column", {
    attrs: {
      width: "180",
      prop: "unit",
      label: "Unit / Transporter"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return scope.row.unit ? [_c("i", {
          staticClass: "el-icon-user"
        }), _vm._v(" " + _vm._s(scope.row.admin.fullName) + " "), _c("br"), _c("i", {
          staticClass: "el-icon-school"
        }), _vm._v(" " + _vm._s(scope.row.unit.name) + " (" + _vm._s(scope.row.unit.code) + ") "), _c("br"), _c("i", {
          staticClass: "el-icon-truck"
        }), _vm._v(" " + _vm._s(scope.row.dealersTransporter.transporter.name) + " ")] : undefined;
      }
    }], null, true)
  }), _c("el-table-column", {
    attrs: {
      width: "100",
      align: "center",
      prop: "totalCartonCount",
      label: "Total Carton"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-button", {
          attrs: {
            type: "primary",
            round: "",
            size: "mini"
          }
        }, [_vm._v(" " + _vm._s(scope.row.totalCartonCount) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "140",
      align: "center",
      label: "Grand Total",
      prop: "grandTotal"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("inr", {
          attrs: {
            number: scope.row.grandTotal
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "180",
      label: "E-way / E-invoice",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [scope.row.ewayBillNo ? _c("div", [_vm._v(" Eway Bill No: "), _c("br"), _vm._v(" " + _vm._s(scope.row.ewayBillNo) + " "), scope.row.ewayBillUrl ? _c("el-link", {
          attrs: {
            type: "primary",
            icon: "el-icon-link",
            target: "_blank",
            href: _vm.getFormatedURL(scope.row.ewayBillUrl)
          }
        }) : _vm._e(), scope.row.ewayCancelDate ? _c("el-popover", {
          attrs: {
            placement: "top-start",
            title: "Eway Cancelled Date",
            width: "200",
            trigger: "hover",
            content: _vm._f("moment")(scope.row.ewayCancelDate, "DD-MM-YYYY hh:mm a")
          }
        }, [_c("el-tag", {
          attrs: {
            slot: "reference",
            size: "mini",
            type: "danger"
          },
          slot: "reference"
        }, [_vm._v(" Cancelled ")])], 1) : _vm._e(), _c("hr", {
          staticStyle: {
            color: "#ccc"
          }
        })], 1) : _vm._e(), scope.row.irn ? _c("div", [_vm._v(" E-Invoice ACK No: "), _c("br"), _vm._v(" " + _vm._s(scope.row.ackNumber) + " "), _c("el-link", {
          attrs: {
            type: "primary",
            icon: "el-icon-link",
            target: "_blank",
            href: scope.row.eInvoiceUrl
          }
        }), scope.row.eInvoiceCancelDate ? _c("el-popover", {
          attrs: {
            placement: "top-start",
            title: "E-Invoice Cancelled Date",
            width: "200",
            trigger: "hover",
            content: _vm._f("moment")(scope.row.eInvoiceCancelDate, "DD-MM-YYYY hh:mm a")
          }
        }, [_c("el-tag", {
          attrs: {
            slot: "reference",
            size: "mini",
            type: "danger"
          },
          slot: "reference"
        }, [_vm._v(" Cancelled ")])], 1) : _vm._e()], 1) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: _vm.$t("table.createdDate"),
      width: "180",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(_vm._f("moment")(scope.row.createdTimestamp, "DD-MM-YYYY hh:mm a")) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      align: "center",
      label: "Actions",
      width: "150",
      fixed: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-tooltip", {
          staticClass: "item",
          attrs: {
            effect: "dark",
            content: "Info",
            placement: "top"
          }
        }, [_c("router-link", {
          attrs: {
            to: "/orders-dispatches/info/" + scope.row.id
          }
        }, [!_vm.isReadOnly ? _c("el-button", {
          attrs: {
            type: "warning",
            size: "mini",
            icon: "el-icon-info"
          }
        }) : _vm._e()], 1)], 1), _vm._v("   "), scope.row.status === "Approved" || scope.row.status === "In Transit" ? _c("el-dropdown", {
          attrs: {
            size: "mini",
            "split-button": "",
            type: "primary"
          },
          on: {
            click: function ($event) {
              return _vm.downloadInvoice(scope.row.id);
            }
          }
        }, [scope.row.status === "Approved" || scope.row.status === "In Transit" ? _c("el-tooltip", {
          staticClass: "item",
          attrs: {
            effect: "dark",
            content: "Invoice",
            placement: "top"
          }
        }, [_c("i", {
          staticClass: "el-icon-document"
        })]) : _vm._e()], 1) : _vm._e()];
      }
    }])
  })], 1), _c("pagination", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.total > 0,
      expression: "total > 0"
    }],
    attrs: {
      total: _vm.total,
      page: _vm.listQuery.page,
      limit: _vm.listQuery.limit
    },
    on: {
      "update:page": function ($event) {
        return _vm.$set(_vm.listQuery, "page", $event);
      },
      "update:limit": function ($event) {
        return _vm.$set(_vm.listQuery, "limit", $event);
      },
      pagination: _vm.getList
    }
  }), _c("el-dialog", {
    attrs: {
      title: "Order Dispatch Details",
      width: "90%",
      visible: _vm.dialogVisible
    },
    on: {
      "update:visible": function ($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_vm._v(" Products dispatched "), _c("dispatch-list", {
    key: _vm.dispatchId,
    attrs: {
      "orders-dispatch-id": _vm.dispatchId
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };